module.exports = __webpack_public_path__ + "static/media/hull_color_style_0004.6b194b7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/hull_color_style_0004.jpg
// module id = 622
// module chunks = 0